import { apiClient } from 'src/api';

export const getUsers = async (val: string) => {
    return await apiClient.get(`/profile/search-snippets?string=${val}`);
};

export const getUsersForMention = async (val: string) => {
    return await apiClient.get(`/estate/comment-snippets?string=${val}`);
};
